import React, { useContext } from 'react';

import { motion as m } from 'framer-motion';

import { CursorContext } from '../context/CursorContext';
import { animationVariants } from '../config/animationConstants';

const Home = () => {
  const { mouseEnterHandler, mouseLeaverHandler } = useContext(CursorContext);

  return (
    <div className='flex items-center justify-center h-screen w-full bg-primary'>
      <m.div
        initial='hidden'
        animate='visible'
        variants={animationVariants}
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaverHandler}
        className='px-4 text-center text-secondary'
        style={{ fontFamily: 'Ledger, serif',  fontWeight: 'bolder'}}
      >
        <m.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className='mb-4 text-4xl md:text-5xl lg:text-8xl'
        >
          Taguhi Karakashyan
        </m.h1>
        <m.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          className='text-base md:text-lg lg:text-5xl'
        >
          Front-End Developer
        </m.p>
      </m.div>
    </div>
  );
};

export default Home;
